import { useState, type MouseEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../lib/AuthContext';
import { ROLE_LABELS } from '../lib/types';

export default function UserMenu() {
  const { claims, roles, fullName, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const initial = (fullName ?? claims?.email)?.[0]?.toUpperCase() ?? '?';
  const roleLabel = roles.map((r) => ROLE_LABELS[r]).join(' + ') || 'keine Rolle';

  return (
    <>
      <IconButton
        onClick={(e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)}
        sx={{ ml: 1 }}
        aria-label="Benutzermenü"
      >
        <Avatar sx={{ width: 32, height: 32 }}>{initial}</Avatar>
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem disabled>
          <ListItemText
            primary={fullName ?? claims?.email}
            secondary={fullName ? `${claims?.email} · ${roleLabel}` : roleLabel}
          />
        </MenuItem>
        <Divider />
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Abmelden" />
        </MenuItem>
      </Menu>
    </>
  );
}
